/**
 * VideoCreatorScreen.js - Main container for Video Creation feature
 * Supports Quick Mode and Advanced Mode
 */

import React, { useState, useCallback } from "react";
import { FiZap, FiSliders, FiVideo } from "react-icons/fi";
import "./styles/VideoCreator.css";

// Components
import QuickModePanel from "./VideoCreator/QuickModePanel";
import AdvancedModePanel from "./VideoCreator/AdvancedModePanel";

const VideoCreatorScreen = ({ initialMode = "quick" }) => {
  const [mode, setMode] = useState(initialMode);
  const [sharedImages, setSharedImages] = useState([]);
  const [sharedResult, setSharedResult] = useState(null);

  // Handle switching from Quick Mode to Advanced Mode with data
  const handleQuickModeComplete = useCallback((result, images) => {
    setSharedResult(result);
    setSharedImages(images);
    // Automatically switch to Advanced Mode for preview/export
    setMode("advanced");
  }, []);

  // Handle switching modes manually
  const handleModeChange = (newMode) => {
    setMode(newMode);
  };

  return (
    <div className="video-creator-container">
      {/* Header */}
      <div className="video-creator-header">
        <h1 className="video-creator-title">
          <FiVideo style={{ marginRight: "0.5rem" }} />
          Tạo Video AI
        </h1>
        <p className="video-creator-subtitle">
          Tạo video quảng cáo chuyên nghiệp từ hình ảnh của bạn
        </p>
      </div>

      {/* Mode Switcher */}
      <div className="mode-switcher">
        <button
          className={`mode-button ${mode === "quick" ? "active" : ""}`}
          onClick={() => handleModeChange("quick")}
        >
          <FiZap />
          <span>Nhanh</span>
        </button>
        <button
          className={`mode-button ${mode === "advanced" ? "active" : ""}`}
          onClick={() => handleModeChange("advanced")}
        >
          <FiSliders />
          <span>Nâng cao</span>
        </button>
      </div>

      {/* Mode Panels */}
      {mode === "quick" ? (
        <QuickModePanel
          onComplete={handleQuickModeComplete}
          existingImages={sharedImages}
        />
      ) : (
        <AdvancedModePanel
          initialImages={sharedImages}
          initialResult={sharedResult}
          onReset={() => {
            setSharedImages([]);
            setSharedResult(null);
          }}
        />
      )}
    </div>
  );
};

export default VideoCreatorScreen;
